<template>
  <div>
    <el-popover
      ref="status"
      v-model="isOpen"
      placement="right"
      title="Státusz beállítása"
      width="150"
      trigger="click"
    >
      <div class="todo-status-setter">
        <p v-if="todo.status !== 'todo'">
          <el-button
            :type="TODO_STATUS.todo.type"
            size="mini"
            :loading="todo_LOADER"
            @click="setStatus('todo')"
          >
            {{ TODO_STATUS.todo.title }}
          </el-button>
        </p>
        <p v-if="todo.status !== 'in-progress'">
          <el-button
            :type="TODO_STATUS['in-progress'].type"
            size="mini"
            @click="setStatus('in-progress')"
          >
            {{ TODO_STATUS['in-progress'].title }}
          </el-button>
        </p>
        <p v-if="todo.status !== 'done'">
          <el-button
            :type="TODO_STATUS.done.type"
            size="mini"
            :loading="done_LOADER"
            @click="setStatus('done')"
          >
            {{ TODO_STATUS.done.title }}
          </el-button>
        </p>
      </div>
    </el-popover>
    <el-tag
      slot="reference"
      v-popover:status
      :type="getStatus(todo).type"
      style="cursor: pointer;"
    >
      <i class="el-icon-check" v-if="todo.status === 'done'"></i> {{ getStatus(todo).title }}
    </el-tag>
  </div>
</template>

<script>
export default {
  propName: 'status',
  props: ['todo', 'type'],
  data() {
    return {
      isOpen: false,
      todo_LOADER: false,
      ['in-progress_LOADER']: false,
      done_LOADER: false,
      TODO_STATUS: {
        todo: {
          type: 'danger',
          title: 'Elintézendő',
        },
        ['in-progress']: {
          type: 'warning',
          title: 'Folyamatban',
        },
        done: {
          type: 'success',
          title: 'Kész',
        }
      }
    };
  },
  methods: {
    getStatus(todo) {
      if (todo.status) {
        return this.TODO_STATUS[todo.status];
      }
    },
    async setStatus(status) {
      this[`${status}_LOADER`] = true;
      await this.$store.dispatch('todo/update', {
        id: this.todo.id,
        status,
      });
      this.isOpen = false;
      this[`${status}_LOADER`] = false;
      if (this.type === 'myTodos') {
        this.$store.dispatch('todo/fetchMyTodos');
      } else {
        this.$store.dispatch('todo/fetchAll');
      }
    }
  }
};
</script>

<style>
  .todo-status-setter p:last-child {
    margin-bottom: 0;
  }
</style>
